// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"StoryFront_heroContainer__rIHHF","mainContainer":"StoryFront_mainContainer__4tD3b","tabCardsContainer":"StoryFront_tabCardsContainer__ZpSYj"};